import React, { useEffect, useState, useCallback, useReducer } from 'react';
import '../../Assets/css/view.css';
import getData from "../../Custome_Components/commonAPISelect";
import getData2 from "../../Custome_Components/commonAPISelect2";
import CustomDropdown from '../../Custome_Components/CustomeDropdown';
import { toast } from "react-toastify";
import { IoCloseOutline } from "react-icons/io5";
import { PiListPlus } from "react-icons/pi";
import { PiFilePdfThin } from "react-icons/pi";
import { PiFileTxtThin } from "react-icons/pi";
import { PiFileXlsThin } from "react-icons/pi";
import { PiFileDocThin } from "react-icons/pi";
import { MdRemoveRedEye } from "react-icons/md";
import { IoIosSearch } from "react-icons/io";
import { styled } from '@mui/material/styles';
import { MdEdit } from "react-icons/md";
import { ImAttachment } from "react-icons/im";
import { IoClose } from "react-icons/io5";
import { AiOutlineClose } from "react-icons/ai";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Button } from "@mui/material";
import Modal from "@mui/material/Modal";

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: '14px',
    },
}));

const debounce = (func, delay) => {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
};

const UpdateTaskReducer = (state, action) => {
    switch (action.type) {
        case 'IssuePointCode':
            return { ...state, IssuePointCode: action.payload };

        case 'issuePointsName':
            return { ...state, issuePointsName: action.payload };

        case 'IssuePointRemark':
            return { ...state, IssuePointRemark: action.payload };

        case 'IssueStatusName':
            return { ...state, IssueStatusName: action.payload };

        case 'IssueStatusIDPK':
            return { ...state, IssueStatusIDPK: action.payload };

        case 'IssueRowIDPK':
            return { ...state, IssueRowIDPK: action.payload };

        case 'ClearField':
            return { ...state, [action.payload]: '' };

        case 'Reset':
            return initialState;

        default:
            return state;
    }
};

const initialState = {
    IssueRowIDPK: '',
    IssuePointCode: '',
    issuePointsName: '',
    IssuePointRemark: '',
    IssueStatusIDPK: '',
    IssueStatusName: '',
}


const View = (props) => {
    const { ComplaintIDPK, Modalloading, TaskStatusIDPK } = props;
    const [state, dispatch] = useReducer(UpdateTaskReducer, initialState);
    const [attachDatas, setAttachDatas] = useState(null);
    const [attachDatasView, setAttachDatasView] = useState(false);
    const [activePage, setActivePage] = useState("Points");
    const [issuePointsData, setIssuePointsData] = useState([]);
    const [IssueSearchTerm, setIssueSearchTerm] = useState("");
    const [IssueFilteredData, setIssueFilteredData] = useState([]);
    const [IssueImgFiles, setIssueImgFiles] = useState([]);
    const [convertedIssueAttach, setConvertIssueAttach] = useState([]);
    const [IssueAttachDatas, setIssueAttachDatas] = useState([]);
    const [IssuePointAttachModal, setIssuePointAttachModal] = useState(false);
    const [IssueCreationModal, setIssueCreationModal] = useState(false);
    const [IsEditIssue, setIsEditIssue] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const resetKey = 0;

    const IssueStatusList = [
        { IssueStatusIDPK: 1, IssueStatusName: "None" },
        { IssueStatusIDPK: 2, IssueStatusName: "Pass" },
        { IssueStatusIDPK: 3, IssueStatusName: "Fail" },
        { IssueStatusIDPK: 4, IssueStatusName: "Repeated Issue" },
        { IssueStatusIDPK: 5, IssueStatusName: "Not Applicable" },
        { IssueStatusIDPK: 6, IssueStatusName: "Discussion" }
    ];

    useEffect(() => {
        IssuePointsTableSelect();
    }, [ComplaintIDPK])

    useEffect(() => {
        if (!IssueSearchTerm) {
            setIssueFilteredData(issuePointsData);
        } else {
            if (issuePointsData.length > 0) {
                IssueApplySearchFilter(IssueSearchTerm);
            }
        }
    }, [IssueSearchTerm, issuePointsData]);

    useEffect(() => {
        if (IssueImgFiles && IssueImgFiles.length > 0) {
            convertFilesToBase64(IssueImgFiles)
                .then((result) => {
                    setConvertIssueAttach(result);
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }
    }, [IssueImgFiles]);

    const convertFilesToBase64 = (files) => {
        return Promise.all(
            files.map((file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();

                    const getFileType = (type, name) => {
                        if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                            return "xlsx";
                        }
                        if (name.toLowerCase().endsWith(".sql")) {
                            return "txt";
                        }
                        if (!type || type === "") {
                            return "txt";
                        }
                        return name.split(".").pop();
                    };
                    reader.onload = (event) => {
                        const base64data = event.target.result.split(",")[1];
                        resolve({
                            base64data,
                            filename: file.name,
                            type: getFileType(file.type, file.name),
                        });
                    };
                    reader.onerror = (error) => reject(error);
                    if (!file.type || file.type === "") {
                        file = new File([file], `${file.name}.txt`, { type: "text/plain" });
                    }
                    reader.readAsDataURL(file);
                });
            })
        );
    };

    const handleFilePreviewView = (fileData) => {
        if (!fileData || !fileData.ImgPath) {
            alert("No file available for preview.");
            return;
        }

        const fileUrl = fileData.ImgPath;
        const fileExtension = fileUrl.split('.').pop().toLowerCase();

        const supportedFormats = [
            "pdf",
            "jpg",
            "jpeg",
            "png",
            "doc",
            "docx",
            "xlsx",
            "txt",
            "sql",
            // ✅ video formats
            "mp4",
            "webm",
            "ogg",
            "mov",
            "avi",
            "mkv"
        ];

        if (!supportedFormats.includes(fileExtension)) {
            alert("File format not supported for preview.");
            return;
        }

        const browserPreviewFormats = [
            "pdf",
            "jpg",
            "jpeg",
            "png",
            "mp4",
            "webm",
            "ogg"
        ];

        if (browserPreviewFormats.includes(fileExtension)) {
            window.open(fileUrl, "_blank");
        } else {
            window.open(fileUrl, "_blank");
        }
    };

    const convertedImageName = (ImageName) => {
        const filename = ImageName;
        const extension = filename.split('.').pop();
        return extension;
    }


    const handleIssuePointEditData = (data) => {
        dispatch({ type: 'IssueRowIDPK', payload: data.CCMIssuePointsDetIDPK ?? null });
        dispatch({ type: 'IssuePointCode', payload: data.IssueCode ?? null });
        dispatch({ type: 'issuePointsName', payload: data.CCMIssueName ?? null });
        dispatch({ type: 'IssuePointRemark', payload: data.Remarks ?? null });
        dispatch({ type: 'IssueStatusIDPK', payload: data.QAStatus ?? 1 });
        dispatch({
            type: 'IssueStatusName', payload: data.QAStatus == 1 ? "None" :
                data.QAStatus == 2 ? "Pass" :
                    data.QAStatus == 3 ? "Fail" :
                        data.QAStatus == 4 ? "Repeated Issue" :
                            data.QAStatus == 5 ? "Not Applicable" :
                                data.QAStatus == 6 ? "Discussion" : ""
        });
    }

    const handleIssuePointCancel = () => {
        dispatch({ type: 'Reset' });
        setIssueImgFiles([]);
        setConvertIssueAttach([]);
    }

    const handleDropdownToggle = (id) => {
        setOpenDropdownId((prevId) => (prevId === id ? null : id));
    };

    const handleDropdownClose = () => {
        setOpenDropdownId(null);
    };

    const handleClearField = (fieldID, fieldName) => {
        dispatch({ type: 'ClearField', payload: fieldID });
        dispatch({ type: 'ClearField', payload: fieldName });
    };

    const IssueAttactFileChange = (event) => {
        const newFiles = Array.from(event.target.files);
        setIssueImgFiles((prevFiles) => [...prevFiles, ...newFiles]);
    };

    const IssueRemoveImgs = (fileName) => {
        setIssueImgFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    };

    const handleFilePreview = (file) => {
        if (file.type.startsWith("image/")) {
            const url = URL.createObjectURL(file);
            window.open(url, "_blank");
        } else if (file.type === "application/pdf") {
            const url = URL.createObjectURL(file);
            window.open(url, "_blank");
        } else {
            alert("Preview not supported for this file type");
        }
    };

    async function AttachSave(ImageArray, TaskIDPK) {
        const url = 'https://smartfm.in/NSEIPLWEBANDMOBILEPORTAL/imageupload.php';
        try {
            await Promise.all(ImageArray.map(async (param) => {
                const requestOptions = {
                    method: 'POST',
                    body: JSON.stringify(param),
                    headers: { 'Content-Type': 'multipart/form-data' },
                };
                const response = await fetch(url, requestOptions);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const responseData = await response.json();
                const imagePath = responseData.filename;
                const url2 = 'https://smartfm.in/NSEIPLWEBANDMOBILEPORTAL/AdminImageRegistry.php';
                const formData = {
                    "AdminImageIDPK_int": "",
                    "ImageCode_varchar": 1,
                    "ImageName_varchar": param.filename,
                    "ImgActualSize_varchar": "",
                    "ImgCompressSize_varchar": "",
                    "ImageSource_image": "",
                    "ImgPath_varchar": imagePath,
                    "ImgType_varchar": "png",
                    "TransType_varchar": "",
                    "ImgProType_int": "",
                    "IsDefault_bit": "",
                    "IsDraft_bit": "",
                    "Remarks_varchar": "",
                    "TransID_int": Number(TaskIDPK),
                    "ModFormID_int": 2,
                    "TransTypeID_int": "",
                    "IsActive_bit": "1",
                    "DeleStat_bit": "",
                    "CreatedUserID_int": "",
                    "CreatedTtm_datetime": "",
                    "UpdatedUserID_int": "",
                    "UpdatedTtm_datetime": ""
                };
                const requestOptions2 = {
                    method: 'POST',
                    body: JSON.stringify(formData),
                    headers: { 'Content-Type': 'multipart/form-data' },
                };
                const response2 = await fetch(url2, requestOptions2);
                if (!response2.ok) {
                    throw new Error('Network response was not ok');
                }
            }));
            setIssueImgFiles([]);
            setConvertIssueAttach([]);
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const AttachmentHandle = async (PointsIDPK) => {
        const result = await getData2("DashboardService/VwAPINSEIPLDetails/", {
            data: {
                p1_int: 84,
                p2_int: PointsIDPK ? Number(PointsIDPK) : null,
                UserID_int: localStorage.getItem("EmpID")
            },
        });
        const { Output: { status, data } } = result;
        if (status.code == "200") {
            const ImageDatas = data.filter(item => item.ImageCode === "1");
            setIssueAttachDatas(ImageDatas);
            if (ImageDatas.length > 0) {
                setIssuePointAttachModal(true);
            } else {
                toast.info("No Attachments Found");
            }
        } else {
            console.error("Error fetching data:", status.message);
        }
    };

    const handleIssuePointsSave = async (ComplaintIDPK) => {
        if (!state.issuePointsName) {
            toast.warning("Kindly enter the points description");
            return false;
        }
        try {
            Modalloading(true);
            const response = await fetch("https://nanotracker.smartfm.cloud/api/CCMSupdate", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    data: {
                        Type: "IssuePointsInsert",
                        CCMComplaintID: ComplaintIDPK ?? 0,
                        CCMStartTime: null,
                        CCMEndTime: null,
                        OberVation: state.issuePointsName ?? null,
                        Rootcause: state.IssuePointRemark ?? null,
                        EmployeeID: localStorage.getItem("EmpID"),
                        ResolutionTime: null,
                        MaintenanceHrs: null,
                        TotalMin: null,
                        CorrectiveAction: null,
                        ServiceCarriedOut: null,
                        ExecEmpID: 0,
                        IssueDepartmentID: 0,
                        IssueDepartmentStatusID: 0,
                        Responsible: null,
                        IsToolUpdate: 0,
                        ToolUpdateRemarks: null,
                        IsRepeted: 0,
                        IsAdditional1: 0,
                        IsAdditional2: null
                    }
                })
            })

            const result = await response.json();
            if (result?.Output?.status?.code == 200) {
                toast.success("Points added successfully");
                if (convertedIssueAttach && convertedIssueAttach.length > 0) {
                    AttachSave(convertedIssueAttach, result?.Output?.data[0].ID);
                }
                dispatch({ type: 'Reset' });
                IssuePointsTableSelect(ComplaintIDPK);
            } else {
                console.error("Error fetching data:", result?.Output?.status?.message);
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        } finally {
            Modalloading(false);
        }
    };

    const handleIssuePointsUpdate = async () => {
        if (!state.issuePointsName) {
            toast.warning("Kindly enter the points description");
            return false;
        }
        try {
            Modalloading(true);
            const response = await fetch("https://nanotracker.smartfm.cloud/api/CCMSupdate", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    data: {
                        Type: "ISSUESINGLEUPDATENEW",
                        CCMComplaintID: state.IssueStatusIDPK ?? 0,
                        CCMStartTime: null,
                        CCMEndTime: null,
                        OberVation: state.issuePointsName ?? null,
                        Rootcause: state.IssuePointRemark ?? null,
                        EmployeeID: localStorage.getItem("EmpID"),
                        ResolutionTime: 0,
                        MaintenanceHrs: null,
                        TotalMin: null,
                        CorrectiveAction: null,
                        ServiceCarriedOut: null,
                        ExecEmpID: state.IssueRowIDPK ?? 0,
                        IssueDepartmentID: 0,
                        IssueDepartmentStatusID: 0,
                        Responsible: null,
                        IsToolUpdate: 0,
                        ToolUpdateRemarks: null,
                        IsRepeted: 0,
                        IsAdditional1: 0,
                        IsAdditional2: null
                    }
                })
            })

            const result = await response.json();
            if (result?.Output?.status?.code == 200) {
                toast.success("Points updated successfully");
                setIssueCreationModal(false);
                setIsEditIssue(false);
                if (convertedIssueAttach && convertedIssueAttach.length > 0) {
                    AttachSave(convertedIssueAttach, state.IssueRowIDPK);
                }
                dispatch({ type: 'Reset' });
                IssuePointsTableSelect(ComplaintIDPK);
            } else {
                console.error("Error fetching data:", result?.Output?.status?.message);
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        } finally {
            Modalloading(false);
        }
    };

    const IssuePointsTableSelect = async () => {
        try {
            const response = await fetch("https://nanotracker.smartfm.cloud/api/CCMSupdate", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    data: {
                        Type: "159",
                        CCMComplaintID: ComplaintIDPK ? Number(ComplaintIDPK) : 0,
                    }
                })
            })

            const result = await response.json();
            if (result?.Output?.status?.code == 200) {
                setIssuePointsData(result.Output.data);
            } else {
                console.error("Error fetching data:", result?.Output?.status?.message);
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };


    const IssueHandleSearchChange = useCallback(
        debounce((value) => {
            setIssueSearchTerm(value);
            if (issuePointsData.length > 0) {
                IssueApplySearchFilter(value);
            }
        }, 300),
        [issuePointsData]
    );

    const IssueApplySearchFilter = (search) => {
        if (issuePointsData.length === 0) {
            return;
        }
        let data = [...issuePointsData];
        const filtered = data.filter((row) =>
            Object.values(row).some((value) =>
                value?.toString().toLowerCase().includes(search.toLowerCase())
            )
        );
        setIssueFilteredData(filtered);
    };

    const renderIssueTableRows = () => {
        const tableDataArray = IssueFilteredData;
        if (tableDataArray.length === 0) {
            return (
                <tr>
                    <td colSpan="13" className="PointsTableTDNoDatastyle">
                        No More Points Found
                    </td>
                </tr>
            );
        }

        return Array.isArray(tableDataArray) && tableDataArray.map((row, index) => (
            <tr
                role="button"
                tabIndex="0"
                key={index}
                className="TbodyTableRowStyle"
            >
                <td className="PointsTableTDstyle" style={{ textAlign: "center" }}
                    onClick={() => { setIsEditIssue(true); setIssueImgFiles([]); setConvertIssueAttach([]); setIssueCreationModal(true); handleIssuePointEditData(row) }}>
                    <BootstrapTooltip title={row.RaisedBy} placement="top-start">
                        <MdEdit style={{ fontSize: "18px", marginRight: "2px", cursor: "pointer" }} />
                    </BootstrapTooltip>
                </td>
                <td className="PointsTableTDstyle" style={{ marginLeft: "5px" }}
                    onClick={() => AttachmentHandle(row.CCMIssuePointsDetIDPK)}>
                    <BootstrapTooltip title={"Attach"} placement="top-start">
                        <ImAttachment style={{ fontSize: "14px", marginRight: "2px", cursor: "pointer" }} />
                    </BootstrapTooltip>
                </td>
                <td className="PointsTableTDstyle">
                    <BootstrapTooltip title={row.CCMIssueName} placement="top-start">{row.CCMIssueName ?? null}</BootstrapTooltip>
                </td>
                <td className="PointsTableTDstyle">
                    <BootstrapTooltip title={row.Remarks} placement="top-start">{row.Remarks ?? null}</BootstrapTooltip>
                </td>
                <td className="PointsTableTDstyle">
                    <span className="IssueTableStatusData" style={{
                        backgroundColor: !row.QAStatus ? "" : row.QAStatus == 2 ? "#0080001c" : row.QAStatus == 3 ? "#ff00001a" : "#00000014",
                        color: !row.QAStatus ? "" : row.QAStatus == 2 ? "green" : row.QAStatus == 3 ? "#d80000" : "#333"
                    }}>
                        <BootstrapTooltip title={row.QAStatus == 1 ? "None" :
                            row.QAStatus == 2 ? "Pass" :
                                row.QAStatus == 3 ? "Fail" :
                                    row.QAStatus == 4 ? "Repeated Issue" :
                                        row.QAStatus == 5 ? "Not Applicable" :
                                            row.QAStatus == 6 ? "Discussion" : "-"} placement="top-start">
                            {row.QAStatus == 1 ? "None" :
                                row.QAStatus == 2 ? "Pass" :
                                    row.QAStatus == 3 ? "Fail" :
                                        row.QAStatus == 4 ? "Repeated Issue" :
                                            row.QAStatus == 5 ? "Not Applicable" :
                                                row.QAStatus == 6 ? "Discussion" : "-"}</BootstrapTooltip>
                    </span>
                </td>
            </tr>
        ));
    };

    return (
        <div>
            <div className="SubTaskSection">
                <div className="SubTasksDiv">
                    <div className="TaskActionsList">
                        <div className="ActionsParent" onClick={() => { setActivePage("Points"); setIssueSearchTerm(''); }}
                            style={{
                                borderBottom: activePage === "Points" ? "2px solid #0F4495" : "2px solid #FFF"
                            }}>
                            <PiListPlus style={{ fontSize: "21px", color: "#333" }} />
                            <span className="ActionTitleTxt">Ticket Points</span>
                            <div className="SubTaskCountStyle">
                                <span className="SubTaskCountFontStyle">{IssueFilteredData.length}</span>
                            </div>
                        </div>
                    </div>

                    <div className="TaskActionsButtons">
                        {activePage === "Points" && <div className="AnimateSearchParent">
                            <input
                                type="text"
                                placeholder="Search here"
                                value={IssueSearchTerm}
                                className="AnimateSearchInput"
                                onChange={(e) => {
                                    setIssueSearchTerm(e.target.value);
                                    IssueHandleSearchChange(e.target.value);
                                }}
                            />
                            <button
                                type="button"
                                className="AnimateSearchBtn"
                                onClick={() => { setIssueSearchTerm('') }}
                                style={{ pointerEvents: IssueSearchTerm ? 'auto' : 'none' }}
                            >
                                <IoIosSearch className={`AnimateSearIcon ${IssueSearchTerm ? 'hide' : ''}`} />
                                <IoCloseOutline className={`AnimateClearIcon ${IssueSearchTerm ? 'show' : ''}`} />
                            </button>
                        </div>}

                        {/* {activePage === "Points" && <ExportTableToExcel
                                    tableData={IssueFilteredData} columnConfig={IssueColumns} fileName="Points" />} */}

                        {activePage === "Points" && TaskStatusIDPK != 1 &&
                            <Button
                                variant="contained"
                                onClick={() => { setIssueImgFiles([]); setConvertIssueAttach([]); setIssueCreationModal(true) }}
                                className="TaskDetAdmUpdateBtn"
                            >
                                Add Points
                            </Button>
                        }
                    </div>
                </div>

                <div>
                    {activePage === "Points" && (
                        <>
                            <table className="TabelTagStyle" style={{ marginTop: "6px" }}>
                                <thead className="theadStyleForChecklist">
                                    <tr>
                                        <th className="TabelTHstyle" style={{ width: "8%", textAlign: "center" }}>Edit</th>
                                        <th className="TabelTHstyle" style={{ width: "8%" }}>Attach</th>
                                        <th className="TabelTHstyle" style={{ width: "35%" }}>Points Description</th>
                                        <th className="TabelTHstyle" style={{ width: "34%" }}>Remarks</th>
                                        <th className="TabelTHstyle" style={{ width: "15%" }}>Status</th>
                                    </tr>
                                </thead>
                                <tbody className="TbodyStyle">{renderIssueTableRows()}</tbody>
                            </table>
                        </>
                    )}
                </div>

            </div>

            {/* ************* Points Creation Modal ****************** */}
            <Modal
                open={IssueCreationModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                disableEnforceFocus
                className="WeeklyTransferModalParent"
            >
                <div className={IsEditIssue ? "IssuePointCreationModal1" : "IssuePointCreationModal2"}>
                    <div className="TopBar">
                        <div className="TaskCountParentSec">{IsEditIssue ? "Update Points" : "Add Points"}</div>
                        <div className="IoCloseDivStyle" onClick={() => {
                            setIssueCreationModal(false);
                            setIsEditIssue(false); handleIssuePointCancel();
                        }}>
                            <IoClose style={{ fontSize: "20px", cursor: "pointer", color: '#ff2b2b' }} /></div>
                    </div>
                    <div className="IssueCreationParent">

                        <div className="IssueBothAttchBtn">
                            <div className="IssueAttachmentContainer">
                                <input
                                    type="file"
                                    multiple
                                    style={{ display: "none" }}
                                    id="IssueFileInput"
                                    onChange={(e) => IssueAttactFileChange(e)}
                                />

                                <label htmlFor="IssueFileInput" className="UpdateAttLabText">
                                    <ImAttachment style={{ fontSize: "16px", marginRight: "2px", cursor: "pointer" }} />Attach
                                </label>
                            </div>
                        </div>

                        {IssueImgFiles && IssueImgFiles.length > 0 &&
                            <div className="IssueImgFileList">
                                {IssueImgFiles.map((file) => (
                                    <div key={file.name} className="IssueTaskDetFileItem" onDoubleClick={() => handleFilePreview(file)}>
                                        <div className="TaskDetFileName">{file.name}</div>
                                        <AiOutlineClose className="TaskDetCloseIcon" onClick={() => IssueRemoveImgs(file.name)} />
                                    </div>
                                ))}
                            </div>}

                        {IsEditIssue && <div className="IssueEditFieldsParent">
                            <div className='IssuePointInputParent33'>
                                <label className='URfieldLabelText'>Points Code</label>
                                <div className="URinputWrapper">
                                    <input
                                        className="checklistInputSty"
                                        value={state.IssuePointCode}
                                        disabled={true}
                                    />
                                </div>
                            </div>

                            <div className='IssuePointInputParent33'>
                                <label className='URfieldLabelText'>Status</label>
                                <div className='ContractDropdownParent'>
                                    <CustomDropdown
                                        id="dropdown10"
                                        isOpen={openDropdownId === 'dropdown10'}
                                        onToggle={() => handleDropdownToggle('dropdown10')}
                                        onClose={handleDropdownClose}
                                        key={resetKey + 10}
                                        dataList={IssueStatusList}
                                        value={state.IssueStatusName}
                                        onItemSelect={(id, val) => {
                                            dispatch({ type: 'IssueStatusIDPK', payload: id });
                                            dispatch({ type: 'IssueStatusName', payload: val });
                                        }}
                                        clearInput={() => {
                                            handleClearField('IssueStatusIDPK', 'IssueStatusName');
                                        }}
                                        labelKey="IssueStatusName"
                                        idKey="IssueStatusIDPK"
                                    />
                                </div>
                            </div>
                        </div>}

                        <div className='IssuePointInputParent'>
                            <label className='URfieldLabelText'>Points Description<span style={{ color: "red" }}>*</span> </label>
                            <div className="URinputWrapper">
                                <textarea
                                    className="IssuePointTextAreaSty"
                                    value={state.issuePointsName}
                                    onChange={(e) => dispatch({ type: 'issuePointsName', payload: e.target.value })}
                                />
                            </div>
                        </div>

                        {!IsEditIssue && <div className='IssuePointInputParent'>
                            <label className='URfieldLabelText'>Remarks</label>
                            <div className="URinputWrapper">
                                <textarea
                                    className="IssuePointTextAreaSty"
                                    value={state.IssuePointRemark}
                                    onChange={(e) => dispatch({ type: 'IssuePointRemark', payload: e.target.value })}
                                />
                            </div>
                        </div>}

                        {IsEditIssue && <div className="IssuePointInputParent">
                            <label className='URfieldLabelText'>Remarks</label>
                            <div className="URinputWrapper">
                                <textarea
                                    className="IssuePointTextAreaSty"
                                    value={state.IssuePointRemark}
                                    onChange={(e) => dispatch({ type: 'IssuePointRemark', payload: e.target.value })}
                                />
                            </div>
                        </div>}

                        <div className="IssuePointsSaveBtns">
                            <Button variant="contained" onClick={() => { setIssueCreationModal(false); handleIssuePointCancel(); }} className="IssueCancelButton"
                            >Cancel</Button>

                            {!IsEditIssue && <Button variant="contained" onClick={() =>
                                handleIssuePointsSave(ComplaintIDPK)
                            } className="IssueSaveButton"
                            >  Save
                            </Button>}

                            {IsEditIssue && <Button variant="contained" onClick={() => handleIssuePointsUpdate()} className="IssueSaveButton"
                            >  Update </Button>}
                        </div>
                    </div>
                </div>
            </Modal>

            {/* ************* Ticket Points Attachments Modal ****************** */}
            <Modal
                open={IssuePointAttachModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                disableEnforceFocus
                className="WeeklyTransferModalParent"
            >
                <div className="IssuePointAttchModal">
                    <div className="TopBar">
                        <div className="TaskCountParentSec">Ticket Points Attachments </div>
                        <div className="IoCloseDivStyle" onClick={() => { setIssuePointAttachModal(false); setIssueAttachDatas([]); }}>
                            <IoClose style={{ fontSize: "20px", cursor: "pointer", color: '#ff2b2b' }} /></div>
                    </div>

                    <div className="IssueAttachDataSection">
                        {IssueAttachDatas && IssueAttachDatas.map((val) => {
                            return (
                                <div className="IssueAttachDataDiv" key={val.ImageName}>
                                    <div className="AttachImgSection">
                                        {["jpg", "jpeg", "png"].includes(convertedImageName(val.ImgPath)) ?
                                            <img src={val.ImgPath} alt="Image" className="AttachImgStyle" />
                                            : ["pdf"].includes(convertedImageName(val.ImgPath)) ?
                                                <div className="FileExtensionImgDiv"><PiFilePdfThin style={{ fontSize: "60px" }} /></div>
                                                : ["txt"].includes(convertedImageName(val.ImgPath)) ?
                                                    <div className="FileExtensionImgDiv"><PiFileTxtThin style={{ fontSize: "60px" }} /></div>
                                                    : ["xlsx"].includes(convertedImageName(val.ImgPath)) ?
                                                        <div className="FileExtensionImgDiv"><PiFileXlsThin style={{ fontSize: "60px" }} /></div>
                                                        : ["docx"].includes(convertedImageName(val.ImgPath)) ?
                                                            <div className="FileExtensionImgDiv"><PiFileDocThin style={{ fontSize: "60px" }} /></div>
                                                            : ''}
                                    </div>
                                    <div className="AttachImgDetails">
                                        <BootstrapTooltip title={val.ImageName} placement="top-start">
                                            <span className="AttachImgName description-cell">{val.ImageName}</span>
                                        </BootstrapTooltip>
                                        <div className="AttachViewDiv" onClick={() => handleFilePreviewView(val)}>
                                            <MdRemoveRedEye style={{ width: '16px', height: "16px" }} />
                                            <span className="AttachViewtext">View</span>
                                        </div>
                                    </div>
                                </div>);
                        })
                        }
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default View
